<nav>
  <ol class="stepper text-bottom count">
    <li class=" text-uppercase" [class.visited]="isVisited(3)" [class.current]="isCurrent(3)">
      <span (click)="goToStepThree()">{{ 'Booking.label_Step3' | translate }}</span>
    </li>
    <li class=" text-uppercase" [class.visited]="isVisited(4)" [class.current]="isCurrent(4)">
      <span (click)="goToStepFour()">{{ 'Booking.label_Step4' | translate }}</span>
    </li>
    <li class=" text-uppercase" [class.visited]="isVisited(5)" [class.current]="isCurrent(5)">
      <span (click)="goToStepFive()">{{ 'Booking.label_Step5' | translate }}</span>
    </li>
    <li class=" text-uppercase" [class.visited]="isVisited(6)" [class.current]="isCurrent(6)">
      <span>{{ 'Booking.label_Step6' | translate }}</span>
    </li>
  </ol>
</nav>
